/**
 * This provider setup is following the Auth0 reccomendation
 * for working with react-router-dom v6
 *
 * https://github.com/auth0/auth0-react/blob/main/EXAMPLES.md#protecting-a-route-in-a-react-router-dom-v6-app
 */

import { type ReactNode, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { getEnvConfig } from "@app/utils";
import { Auth0Provider } from "@auth0/auth0-react";

export const AuthProvider = (props: { children?: ReactNode }) => {
  const env = useMemo(() => {
    return getEnvConfig();
  }, []);
  const navigate = useNavigate();
  const handleAuthRedirect = useCallback(
    (appState) => {
      navigate((appState && appState.returnTo) || window.location.pathname);
    },
    [navigate]
  );

  return (
    <Auth0Provider
      domain={env.AUTH0_DOMAIN}
      clientId={env.AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: env.AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={handleAuthRedirect}
    >
      {props.children}
    </Auth0Provider>
  );
};
